import * as types from './mutations-types'

export default {
  [types.RANK_EQUITY_LIST] (state, data) {
    state.rankEquityList = data.dataList
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/rank-equity/store/mutations.js